import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 border-t border-[color:var(--nccc-border)] mt-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="label-accent mb-3">// 001</div>
          <h4 className="font-display text-2xl text-[color:var(--nccc-cream)] mb-2">
            New Counter Culture Collective
          </h4>
          <p className="text-sm text-[color:var(--nccc-muted)] leading-relaxed mb-6">
            Sheffield-based record label and cultural collective. Building an
            emancipatory politics through the movement in emotion.
          </p>
          <div className="label mb-2">// Join the signal</div>
          <NewsletterForm source="footer" testid="footer-newsletter" />
        </div>
        <div>
          <div className="label-accent mb-3">// Index</div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-[color:var(--nccc-ochre)]">
                Manifesto
              </Link>
            </li>
            <li>
              <Link to="/releases" className="hover:text-[color:var(--nccc-ochre)]">
                Releases
              </Link>
            </li>
            <li>
              <Link to="/portals" className="hover:text-[color:var(--nccc-ochre)]">
                Portals
              </Link>
            </li>
            <li>
              <Link to="/affiliates" className="hover:text-[color:var(--nccc-ochre)]">
                Affiliates
              </Link>
            </li>
            <li>
              <Link to="/submit" className="hover:text-[color:var(--nccc-ochre)]">
                Submit a transmission
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="label-accent mb-3">// Signal</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href="https://nccc.sumupstore.com/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[color:var(--nccc-ochre)]"
                data-testid="footer-store"
              >
                nccc.sumupstore.com ↗
              </a>
            </li>
            <li>
              <a
                href="https://nccc.bandcamp.com/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[color:var(--nccc-ochre)]"
                data-testid="footer-bandcamp"
              >
                nccc.bandcamp.com ↗
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/@NCCCollective"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[color:var(--nccc-ochre)]"
                data-testid="footer-youtube"
              >
                youtube.com/@NCCCollective ↗
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/ncccsheffield"
                target="_blank"
                rel="noreferrer"
                className="hover:text-[color:var(--nccc-ochre)]"
                data-testid="footer-instagram"
              >
                instagram.com/ncccsheffield ↗
              </a>
            </li>
            <li className="text-[color:var(--nccc-muted)]">Sheffield · North of England</li>
            <li>
              <Link
                to="/admin/login"
                className="text-[color:var(--nccc-muted)] hover:text-[color:var(--nccc-ochre)]"
                data-testid="footer-admin-link"
              >
                — operator
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--nccc-border)] py-5 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-wrap justify-between items-center gap-3">
        <span className="label">© NCCC // {new Date().getFullYear()}</span>
        <span className="label-accent">Life is analogue; infinite.</span>
      </div>
    </footer>
  );
}
